import { language } from '@comall-backend-builder/core/lib/services';

var NumberFormat = function () {
  function NumberFormat() {}
  /**
   * 对数据进行校验
   */


  NumberFormat.prototype.validate = function (_rule, value, callback) {
    if (value && !/^\-?[0-9]+\.?[0-9]*$/.test(value)) {
      callback(language.getText('validation.number.default'));
    } else {
      callback();
    }
  };
  /**
   * 将数据格式化为 number 类型的值
   */


  NumberFormat.prototype.format = function (value) {
    if (typeof value !== 'number') {
      value = parseFloat(value);
    } // NaN, +Infinity, -Infinity


    if (Number.isFinite(value) === false) {
      value = undefined;
    }

    return value;
  };
  /**
   * 将数据格式化为请求参数
   */


  NumberFormat.prototype.formatParams = function (key, value) {
    var _a;

    return _a = {}, _a[key] = value, _a;
  };

  return NumberFormat;
}();

export { NumberFormat };